module.exports = __webpack_public_path__ + "media/images/close_btn-11313ad3.svg";